import http from './http-common';

class YarnContractDeliveryScheduleService {
  get(id) {
    return http.get(`/yarncontractdeliveryschedule/${id}`);
  }

  create(data) {
    console.log('create data: ', data);
    return http.post(`/yarncontractdeliveryschedule/`, data);
  }

  update(id,data) {
    return http.put(`/yarncontractdeliveryschedule/${id}`, data);
  }

  delete(id) {
    return http.delete(`/yarncontractdeliveryschedule/${id}`);
  }
}

export default new YarnContractDeliveryScheduleService();
